import { createStore, applyMiddleware, combineReducers } from "redux";
import ProviderReducer from './duck/provider'
import AuthReducer from './duck/auth'
import createSagaMiddleware from "redux-saga";
import { watcherSaga } from "./saga/rootSaga";
import { composeWithDevTools } from 'redux-devtools-extension'



const appReducer = combineReducers({
    provider: ProviderReducer,
    auth: AuthReducer
});


const rootReducer = (state, action) => {
    return appReducer(state, action);
}
const sagaMiddleware = createSagaMiddleware();

const middleware = [sagaMiddleware]

const store =
    createStore(
        rootReducer,
        {},
        composeWithDevTools(applyMiddleware(...middleware))
    );

sagaMiddleware.run(watcherSaga);

export default store;